// extracted by mini-css-extract-plugin
module.exports = {"root":"RemoveButton__root___3hmg7"};